<template>
    <HeaderDropdown
        v-if="
            hasStrategy &&
            (isAdmin ||
                isLocalAdministrator ||
                isGod ||
                (isUser && strategyViewer))
        "
    >
        <template slot="header">
            <span class="active">Strategy</span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item to="/v2/strategy/onepage">
                <span>OnePage</span>
            </b-dropdown-item>
        </template>
    </HeaderDropdown>
</template>
<script>
import { HeaderDropdown } from '@coreui/vue'

export default {
    props: [
        'hasStrategy',
        'isAdmin',
        'isLocalAdministrator',
        'isGod',
        'isUser',
        'strategyViewer',
    ],
    components: {
        HeaderDropdown,
    },
}
</script>
<style scoped>
.active > .badge-news {
    color: white !important;
}
</style>
